import React, {Component} from 'react';
import ReactDOM from "react-dom";
import LoqateService from './services/LoqateService';

class PostCode extends Component {

    constructor(props) {
        super(props);

        this.LoqateService = new LoqateService();

        this.state = {
            postcode: '',
            error: false,
            message: ''
        };

        this.submitPostcode = this.submitPostcode.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    submitPostcode() {
        this.LoqateService.validatePostcode(this.state.postcode)
            .then(() => window.location.href = '/wizard')
            .catch((err) => {
                this.setState({
                    error: true,
                    message: err.response.data.error
                });
            });
    }


    render() {
        return (
            <div className="container-fluid hero-section d-flex">
                <div className="col-12 align-self-center d-flex justify-content-end px-5">
                    <div className="card postcode align-self-center d-flex border-0">
                        <div className="card-body card-grey text-white py-4 px-5">
                            <h2 className="postcode-heading">Lorem Ipsum</h2>
                            <h2 className="postcode-heading">Lorem Ipsum</h2>
                            <p>Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum</p>
                            <div className="row justify-content-center">
                                <span className='mx-2'><input type="text" name='postcode' className='input-postcode' style={{borderRadius: '30px', padding: '11px', width: '150px'}} onChange={(event) => this.handleChange(event)}/></span>
                                {/*<span className="mx-2"><button className="btn btn-round py-3 btn-cw btn-grey">postcode</button></span>*/}
                                <span className="mx-2"><button
                                    className="btn btn-round py-3 btn-cw btn-yellow" onClick={this.submitPostcode}>button</button></span>
                                {this.state.error &&
                                <div><span className='text-danger'>{this.state.message}</span></div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

if (document.getElementById('postCode')) {
    let element = document.getElementById('postCode');
    ReactDOM.render(<PostCode/>, element);
}


export default PostCode;

